import i18n from 'modules/core/lib/i18n'

export const validateTitle = (title: string) => {
  if (title.length === 0) {
    return i18n.t('performance_goals.metric_group_validations.title_cant_be_empty')
  }
}
